import React, { useEffect, useRef, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import "./programmee.css";
import { getHomeData } from "../../data/home";

const HeroCarousel = () => {
  const homeData = getHomeData();
  const programmes = homeData?.programmes || {};
  const { heading, description, programmeCards = [] } = programmes;

  const slides = programmeCards.map((card) => ({ ...card }));

  const wrapperRef = useRef(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [swipeProgress, setSwipeProgress] = useState(0);
  const lastIndexRef = useRef(0);

  useEffect(() => {
    const totalSlides = slides?.length;

    const handleScroll = () => {
      if (!wrapperRef.current) return;
      const rect = wrapperRef.current.getBoundingClientRect();
      const scrolled = -rect.top;
      const slideHeight = window.innerHeight;

      const rawProgress = scrolled / slideHeight;
      const clampedProgress = Math.min(Math.max(rawProgress, 0), totalSlides - 1);

      const currentIndex = Math.min(Math.floor(clampedProgress), totalSlides - 1);
      const fractional = clampedProgress - currentIndex;

      setActiveIndex(currentIndex);
      setSwipeProgress(fractional);
      lastIndexRef.current = currentIndex;
    };

    window.addEventListener("scroll", handleScroll, { passive: true });
    return () => window.removeEventListener("scroll", handleScroll);
  }, [slides.length]);

  const totalSlides = slides?.length;

  // Text updates only when card is 50%+ swiped
  const displayIndex =
    swipeProgress >= 0.5 && activeIndex + 1 < totalSlides
      ? activeIndex + 1
      : activeIndex;

  return (
    <div
      ref={wrapperRef}
      style={{ height: `${totalSlides * 100}vh`, position: "relative" }}
    >
      <section
        className="hero-sections"
        style={{ position: "sticky",height: "calc(100vh - 145px)" }}
      >
        <Container fluid className="col-11 col-md-10 mx-auto h-100">
          <Row className="align-items-center hero-row h-100">

            {/* LEFT: Text content — uses displayIndex */}
            <Col lg={6} className="hero-content">
              <div className="position-relative programmee-htag" style={{ top: "-60px" }}>
                <h1 className="hero-main-title">{heading}</h1>
                <small className="hero-subtitle">{description}</small>
                <div className="mt-5">
                  <h2
                    className="highlight mb-lg-4"
                    key={displayIndex}
                    style={{ animation: "fadeSlideUp 0.5s ease forwards" }}
                  >
                    {slides[displayIndex].title}
                  </h2>
                  <p
                    className="desc "
                    key={`desc-${displayIndex}`}
                    style={{ animation: "fadeSlideUp 0.5s ease 0.1s forwards", opacity: 0 }}
                  >
                    {slides[displayIndex].description}
                  </p>
                </div>
              </div>
            </Col>

            {/* RIGHT: Image stack — uses activeIndex for animation */}
            <Col lg={6} className="hero-image mt-lg-4" style={{ overflow: "hidden" }}>
              <div className="image-stack">

                {/* Card 3 — back (2 slides ahead, only if exists) */}
                {activeIndex + 2 < totalSlides && (
                  <div className="stack-card stack-card-3">
                    <img
                      src={slides[activeIndex + 2].image}
                      alt={slides[activeIndex + 2].alt}
                    />
                  </div>
                )}

                {/* Card 2 — middle (next slide, only if exists) */}
                {activeIndex + 1 < totalSlides && (
                  <div
                    className="stack-card stack-card-2"
                    style={{
                      transform: `rotate(1deg) scale(${0.97 + swipeProgress * 0.03})`,
                      filter: `brightness(${0.75 + swipeProgress * 0.25})`,
                    }}
                  >
                    <img
                      src={slides[activeIndex + 1].image}
                      alt={slides[activeIndex + 1].alt}
                    />
                  </div>
                )}

                {/* Card 1 — front (current slide, swipes out on scroll) */}
                <div
                  className="stack-card stack-card-1"
                  style={{
                    transform: `translateX(${-swipeProgress * 115}%) rotate(-1deg)`,
                    opacity: swipeProgress > 0.7 ? 1 - (swipeProgress - 0.7) / 0.3 : 1,
                    transition: "none",
                  }}
                >
                  <img
                    src={slides[activeIndex].image}
                    alt={slides[activeIndex].alt}
                  />
                </div>

              </div>
            </Col>

          </Row>
        </Container>
      </section>
    </div>
  );
};

export default HeroCarousel;